const NursingcareData = [
  {
    id: 1,
    servicesname: "Oncology Nursing Services",
    totalservices: "Total 10 Service",

    services: [
      {
        id: 1,
        name: "Chemotherapy Disconnect",
        duration: "30 Min",
        offer: "40% Off",
        price: "₹999",
        oldPrice: "(₹1550)"
      },
      {
        id: 2,
        name: "Injection Service",
        duration: "45 Min",
        offer: "20% Off",
        price: "₹799",
        oldPrice: "(₹999)"
      },
      {
        id: 3,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      },
      {
        id: 4,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      },
      {
        id: 5,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      }
    ]
  },
    {
    id: 2,
    servicesname: "ICU at Home Procedures",
    totalservices: "Total 15 Services",

    services: [
      {
        id: 1,
        name: "Chemotherapy Disconnect",
        duration: "30 Min",
        offer: "40% Off",
        price: "₹999",
        oldPrice: "(₹1550)"
      },
      {
        id: 2,
        name: "Injection Service",
        duration: "45 Min",
        offer: "20% Off",
        price: "₹799",
        oldPrice: "(₹999)"
      },
      {
        id: 3,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      },
       {
        id: 4,
        name: "Injection Service",
        duration: "45 Min",
        offer: "20% Off",
        price: "₹799",
        oldPrice: "(₹999)"
      },
      {
        id: 5,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      }
    ]
  },
  {
    id: 3,
    servicesname: "Tracheostomy Care Services",
    totalservices: "Total 15 Services",

    services: [
      {
        id: 1,
        name: "Chemotherapy Disconnect",
        duration: "30 Min",
        offer: "40% Off",
        price: "₹999",
        oldPrice: "(₹1550)"
      },
      {
        id: 2,
        name: "Injection Service",
        duration: "45 Min",
        offer: "20% Off",
        price: "₹799",
        oldPrice: "(₹999)"
      },
      {
        id: 3,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      },
       {
        id: 4,
        name: "Injection Service",
        duration: "45 Min",
        offer: "20% Off",
        price: "₹799",
        oldPrice: "(₹999)"
      },
      {
        id: 5,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      }
    ]
  },
  {
    id: 4,
    servicesname: "Palliative Care Procedures",
    totalservices: "Total 15 Services",

    services: [
      {
        id: 1,
        name: "Chemotherapy Disconnect",
        duration: "30 Min",
        offer: "40% Off",
        price: "₹999",
        oldPrice: "(₹1550)"
      },
      {
        id: 2,
        name: "Injection Service",
        duration: "45 Min",
        offer: "20% Off",
        price: "₹799",
        oldPrice: "(₹999)"
      },
      {
        id: 3,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      },
       {
        id: 4,
        name: "Injection Service",
        duration: "45 Min",
        offer: "20% Off",
        price: "₹799",
        oldPrice: "(₹999)"
      },
      {
        id: 5,
        name: "Dressing Service",
        duration: "60 Min",
        offer: "30% Off",
        price: "₹699",
        oldPrice: "(₹899)"
      }
    ]
  }
];

export default NursingcareData;